import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  fetchData,
  urls,
} from '@internal/backstage-plugin-dh-dock-shared-common';

export interface hierachyProps {
  response: {
    team:string ;
    teamname:string ;
    product: { entityRef: string; title: string,productOwner:string };
    parent: string;
    parentname:string;

  }[];

  loading: boolean;
  error: string | null;
}

const initialState: hierachyProps = {
  response: [],
  loading: false,
  error: null,
};

export const fetchHieracyListAsync = createAsyncThunk(
  'groups/getHierachy',
  async () => {
    const response = await fetchData(urls.getHierachyList);
    return response;
  },
);

const HierachySlice = createSlice({
  name: 'product/groupHieracy',
  initialState,
  reducers: {
    setHierachyList: (state, action) => {
      state.response = action.payload;
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchHieracyListAsync.pending, state => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchHieracyListAsync.fulfilled, (state, action) => {
      state.response = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchHieracyListAsync.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Failed to fetch hierachy list';
    });
  },
});

export const { setHierachyList } = HierachySlice.actions;
export default HierachySlice.reducer;
